(() => {
  const destinations = new Map([
    ['産地・作り手で選ぶ', '/pages/creators'],
    ['おすすめ特集', '/collections/おすすめ作品'],
  ]);

  function repairNavigation() {
    document.querySelectorAll('.mm-title').forEach((label) => {
      const title = label.textContent.trim();
      const destination = destinations.get(title);
      if (!destination) return;
      const anchor = label.closest('a');
      if (!anchor) return;
      anchor.href = destination;
      anchor.dataset.href = destination;
      anchor.setAttribute('onclick', 'mmGoToPage(this, event); return false;');
      anchor.removeAttribute('aria-disabled');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairNavigation, { once: true });
  } else {
    repairNavigation();
  }
  new MutationObserver(repairNavigation).observe(document.documentElement, { childList: true, subtree: true });
})();
